import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8571e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Google Analytics 4", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "&", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Universal Analytics", -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepHeader = _resolveComponent("StepHeader")!
  const _component_StepFooter = _resolveComponent("StepFooter")!
  const _component_StepContainer = _resolveComponent("StepContainer")!

  return (_openBlock(), _createBlock(_component_StepContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_StepHeader, {
        title: _ctx.$t('connection.steps.gaSelection.title')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["ua-container card", { selected: _ctx.selectedGa === _ctx.gaTypes.GA4 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedGa = _ctx.gaTypes.GA4))
        }, " Google Analytics 4 ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["ga4-container card", { selected: _ctx.selectedGa === _ctx.gaTypes.UA }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedGa = _ctx.gaTypes.UA))
        }, _hoisted_5, 2)
      ]),
      _createVNode(_component_StepFooter, {
        disabled: !_ctx.selectedGa,
        onNextPage: _ctx.onNextPage
      }, null, 8, ["disabled", "onNextPage"])
    ]),
    _: 1
  }))
}